"use client";

import { c as _c } from "react/compiler-runtime";
import { IconHeadphonesOutline18 } from "nucleo-ui-outline-18";
import { CaddieAvatar } from "@/components/caddie/CaddieAvatar";
import { Button } from "@/components/ui/button";
import { FIX_WITH_CADDIE_LABEL } from "@/lib/caddie";
interface ErrorModalFooterProps {
  onGetSupport?: () => void;
  onFixWithCaddie?: () => void;
}
export function ErrorModalFooter(t0) {
  const $ = _c(7);
  const {
    onGetSupport,
    onFixWithCaddie
  } = t0;
  if (!onGetSupport && !onFixWithCaddie) {
    return null;
  }
  let t1;
  if ($[0] !== onGetSupport) {
    t1 = onGetSupport ? <Button variant="white" size="lg" className="flex-1" onClick={onGetSupport}><IconHeadphonesOutline18 className="h-4 w-4" />Get Support</Button> : null;
    $[0] = onGetSupport;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onFixWithCaddie) {
    t2 = onFixWithCaddie ? <Button size="lg" className="flex-1" onClick={onFixWithCaddie}><CaddieAvatar size={18} mood="repair" decorated={false} />{FIX_WITH_CADDIE_LABEL}</Button> : null;
    $[2] = onFixWithCaddie;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="border-ds-border-default bg-ds-surface-card sticky bottom-0 flex gap-3 border-t px-6 py-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}